export default function InfoToastIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="29.7041"
				cy="29.7042"
				r="27.7041"
				fill="#FBFBFB"
				fill-opacity="0.1"
			/>
			<circle
				cx="29.7041"
				cy="29.7042"
				r="22.0693"
				fill="#FBFBFB"
				fill-opacity="0.2"
			/>
			<circle cx="29.7038" cy="29.7042" r="14.5564" fill="#FBFBFB" />
			<path
				d="M30.5567 26.9928H28.7483V34.173H30.5567V26.9928Z"
				fill="#1B1B1B"
			/>
			<path
				d="M29.6525 24.582C30.1519 24.582 30.5567 24.1771 30.5567 23.6778C30.5567 23.1784 30.1519 22.7736 29.6525 22.7736C29.1531 22.7736 28.7483 23.1784 28.7483 23.6778C28.7483 24.1771 29.1531 24.582 29.6525 24.582Z"
				fill="#1B1B1B"
			/>
		</svg>
	);
}
